module.exports = __webpack_public_path__ + "img/logo_askmebet.1dcb988f.png";